module.exports = __webpack_public_path__ + "img/mic.d0ce627c.svg";